import React from 'react';

const NonMemberContext = React.createContext();

export default NonMemberContext;
